module.exports = __webpack_public_path__ + "img/electric-mining-drill-W-drill-shadow.060af096.png";